export const hasSelectedText = element => {
    const selection = window.getSelection?.();
    if (!selection || selection.isCollapsed || !selection.toString().trim()) {
        return false;
    }

    if (!element) {
        return true;
    }

    return element.contains(selection.anchorNode) || element.contains(selection.focusNode);
};
